// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"VJ-z","smallCardRow":"WJ-z","largeCardRow":"XJ-z","productSearchRow":"YJ-z","curatedRow":"ZJ-z"};